module.exports = __webpack_public_path__ + "static/media/zliten.17f832ad.png";